import BigNumber from 'bignumber.js'
import crypto from 'crypto'
import { calProbFromHash, HASH_HEX_LENGTH } from './baseFairnessResult'

const targetDecimalPlace = 2

export function generateDiceFairResult(serverSeed: string, clientSeed: string, nonce: number): BigNumber {
  const hash = generateHash(serverSeed, clientSeed, nonce)
  const prob = calProbFromHash(hash, HASH_HEX_LENGTH)
  const result = prob.multipliedBy(100)
  return result.decimalPlaces(targetDecimalPlace, BigNumber.ROUND_DOWN)
}

function generateHash(serverSeed: string, clientSeed: string, nonce: number): string {
  const hmac = crypto.createHmac('sha256', serverSeed)
  hmac.update(`${clientSeed}:${nonce}`)
  return hmac.digest('hex')
}
